var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    clipPath: "url(#clip0_289_34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9558 7.17379C13.5036 7.17379 14.7583 5.91908 14.7583 4.37132C14.7583 2.82356 13.5036 1.56885 11.9558 1.56885C10.4081 1.56885 9.15337 2.82356 9.15337 4.37132C9.15337 5.91908 10.4081 7.17379 11.9558 7.17379Z",
    fill: "#FDE16A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.7661 12.0812L19.1541 11.5364C18.2643 11.35 17.3857 11.7578 16.9213 12.4829C16.4701 12.2512 15.985 12.0514 15.469 11.8856V10.3324C15.4701 9.15725 14.5081 8.19629 13.3371 8.19629H10.6664C9.48922 8.19629 8.53136 9.15725 8.53136 10.3324V11.8938C8.02052 12.0565 7.54056 12.2563 7.08634 12.4891C6.62186 11.7609 5.74226 11.35 4.85135 11.5364L2.23734 12.0812C1.08997 12.3212 0.345309 13.4593 0.585286 14.6108L1.24138 17.7449C1.4793 18.8933 2.61841 19.6379 3.76682 19.398L4.59385 19.2249C5.00786 19.8367 5.58054 20.398 6.31384 20.878C7.84123 21.8791 9.85892 22.4311 12.0001 22.4311C15.2764 22.4311 18.0985 21.1138 19.3982 19.2218L20.2387 19.398C21.386 19.6369 22.5251 18.8933 22.7631 17.7449L23.4202 14.6108C23.6591 13.4593 22.9144 12.3212 21.7661 12.0812ZM11.9991 21.361C10.0649 21.361 8.25214 20.8739 6.89984 19.983C6.43636 19.6801 6.05219 19.3434 5.74427 18.9829L6.37768 18.85C7.5271 18.6111 8.27176 17.473 8.03179 16.3236L7.44368 13.5056C7.78665 13.3213 8.14714 13.1596 8.53027 13.0216V13.5355C8.53027 14.7086 9.49017 15.6696 10.6653 15.6696H13.336C14.5081 15.6696 15.468 14.7076 15.468 13.5355V12.9948C15.8583 13.1338 16.225 13.2935 16.5649 13.4747L15.9685 16.3246C15.7306 17.474 16.4742 18.6121 17.6236 18.8511L18.2632 18.9849C17.0706 20.397 14.7109 21.361 11.9991 21.361Z",
    fill: "#FDE16A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.1975 10.8579C22.7453 10.8579 24 9.60316 24 8.0554C24 6.50764 22.7453 5.25293 21.1975 5.25293C19.6498 5.25293 18.3951 6.50764 18.3951 8.0554C18.3951 9.60316 19.6498 10.8579 21.1975 10.8579Z",
    fill: "#FDE16A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.37744 10.799C4.89351 10.4818 5.86168 8.99559 5.54855 7.48053C5.22927 5.96651 3.74615 4.99424 2.22903 5.31147C0.715016 5.62765 -0.257259 7.11282 0.0599731 8.62789C0.376202 10.144 1.86138 11.1152 3.37744 10.799Z",
    fill: "#FDE16A"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_289_34"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/community.834941b32b935bf110f103547dc2f4c3.svg";
export { ForwardRef as ReactComponent };